import DocsCarrierInfo from './styled';

export default DocsCarrierInfo;
